import React, { useState, useRef } from 'react';
import {
  CuentaDNI,
  CuentaComercios,
  Finanzas1,
  Administra,
  Calendario,
  Seguridad1,
  Contacto1,
  Productivas
} from 'components/articles';
import Button from 'components/ui/button';
import './index.css';

import image from 'assets/images/main-emprendedora.jpg';

export default function Emprendedora() {
  const inputRef = useRef(null);
  const [article, setArticle] = useState(null);
  const variant = "emprendedora";

  const selectArticle = item => {
    setArticle(item);
    const scrollto = inputRef.current.getBoundingClientRect().top + window.scrollY - 150;
    window.scrollTo({ top: scrollto, behavior: 'smooth' });
  }

  return (
    <div className={`wrapper ${variant}`}>
      <div className="content-cols">
        <figure>
          <img src={image} alt="¿Tenés más de 60 años?" />
          <figcaption>¿Sos mujer<br />emprendedora?</figcaption>
        </figure>
        <section className='segment-nav'>
          <Button
            article='cuenta-dni'
            active={article === 'cuenta-dni'}
            onclick={() => selectArticle('cuenta-dni')}
          />
          <Button
            article='cuenta-comercios'
            active={article === 'cuenta-comercios'}
            onclick={() => selectArticle('cuenta-comercios')}
          />
          <Button
            article='productivas'
            active={article === 'productivas'}
            onclick={() => selectArticle('productivas')}
            />
          <Button
            article='finanzas'
            active={article === 'finanzas'}
            onclick={() => selectArticle('finanzas')}
            />
          <Button
            article='administra'
            active={article === 'administra'}
            onclick={() => selectArticle('administra')}
            variant={variant}
          />
          <Button
            article='calendario'
            active={article === 'calendario'}
            onclick={() => selectArticle('calendario')}
          />
          <Button
            article='seguridad'
            active={article === 'seguridad'}
            onclick={() => selectArticle('seguridad')}
          />
          <Button
            article='contacto'
            active={article === 'contacto'}
            onclick={() => selectArticle('contacto')}
          />
        </section>
      </div>
      <div ref={inputRef}>
        {article &&
          <article>
            {article === 'cuenta-dni' && <CuentaDNI variant={variant} />}
            {article === 'cuenta-comercios' && <CuentaComercios />}
            {article === 'productivas' && <Productivas />}
            {article === 'finanzas' && <Finanzas1 />}
            {article === 'administra' && <Administra variant={variant} />}
            {article === 'calendario' && <Calendario variant={3} />}
            {article === 'seguridad' && <Seguridad1 variant={variant} />}
            {article === 'contacto' && <Contacto1 />}
          </article>
        }
      </div>
    </div>
  );
}